export default __webpack_public_path__ + "e46adc6de8574b935d1b8230653d9bc3.png";